export default __webpack_public_path__ + "static/media/workspacesLogo2020-yellow.608eeb73.svg";